import { render, staticRenderFns } from "./PpdDLGDrinkMaterial.vue?vue&type=template&id=7c97ea42&scoped=true&"
import script from "./PpdDLGDrinkMaterial.vue?vue&type=script&lang=js&"
export * from "./PpdDLGDrinkMaterial.vue?vue&type=script&lang=js&"
import style0 from "./PpdDLGDrinkMaterial.vue?vue&type=style&index=0&id=7c97ea42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c97ea42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c97ea42')) {
      api.createRecord('7c97ea42', component.options)
    } else {
      api.reload('7c97ea42', component.options)
    }
    module.hot.accept("./PpdDLGDrinkMaterial.vue?vue&type=template&id=7c97ea42&scoped=true&", function () {
      api.rerender('7c97ea42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/customize/PpdDLGDrinkMaterial.vue"
export default component.exports